import React, { useState, useEffect } from 'react';

import axios from 'axios';
import ServerRow from '../../components/ServerRow';
import ServerOverlay from '../../components/ServerOverlay';

const OUTLINE_GET_LIST_URL = 'https://ger.wa.48.defaultbot.com/v2-api/outline/getList';
const OUTLINE_DISABLE_PROXY_URL = 'https://ger.wa.48.defaultbot.com/v2-api/outline/disableProxy';

export default function Proxies() {
	const [proxies, setProxies] = useState([]);

	useEffect(() => {
		getList();
	}, []);

	const getList = async () => {
		const token = localStorage.getItem('simple_vpn_token');
		if (token === null || token === undefined) {
			alert('Токен не найден');
			return;
		}
		const request = await axios.post(OUTLINE_GET_LIST_URL, {}, { headers: { Authorization: `Bearer ${token}` } });
		const _k = request.data.keys;
		const serversWithEnabledProxies = _k.filter((server) => server.is_proxy_enabled === true);
		const proxiesArray = [];
		serversWithEnabledProxies.forEach((element) => {
			const findExistingProxy = proxiesArray.find((proxy) => proxy.ip === element.proxy_ip);
			if (!findExistingProxy) {
				proxiesArray.push({
					ip: element.proxy_ip,
					servers: 1,
					servers_ips: [`${element.id} (${element.configuration.server})`]
				});
			} else {
				findExistingProxy.servers++;
				findExistingProxy.servers_ips.push(`${element.id} (${element.configuration.server})`);
			}
		});

		setProxies(proxiesArray);
	};

	const disableProxyByIp = async (ip) => {
		const token = localStorage.getItem('simple_vpn_token');
		if (token === null || token === undefined) {
			alert('Токен не найден');
			return;
		}
		const request = await axios.post(OUTLINE_DISABLE_PROXY_URL, { ip: ip }, { headers: { Authorization: `Bearer ${token}` } });
		getList();
	};

	return (
		<>
			<div className='content-block t-container'>
				<div className='t-content'>
					<div className='page-header'>
						<h1>Proxies</h1>
						<div className='header-buttons-group'></div>
					</div>
				</div>
				<div className='row-qiwi labels'>
					<div className='qiwi-column'>Status</div>
					<div className='qiwi-column'>Type</div>
					<div className='qiwi-column'>IP</div>
					<div className='qiwi-column'>Servers Count</div>
					<div className='qiwi-column'>Servers</div>
					<div className='qiwi-column'>Disable</div>
				</div>

				{proxies.map((proxy) => {
					return (
						<div key={proxy.id} className='row-qiwi'>
							<div className='qiwi-column'>
								<div className={'status-round purple'}></div>
							</div>
							<div className='qiwi-column'>PROXY</div>
							<div className='qiwi-column'>{proxy.ip}</div>
							<div className='qiwi-column'>{proxy.servers}</div>
							{/* <div className='qiwi-column wallet-hidden'>{server.api}</div> */}
							<div className='qiwi-column' style={{ flexDirection: 'column', gap: '2px' }}>
								{proxy.servers_ips.map((ips) => {
									return <div>{ips}</div>
								})}
							</div>
							<div className='qiwi-column'>
								<button onClick={() => disableProxyByIp(proxy.ip)} style={{ whiteSpace: 'nowrap' }} className='t-button t-primary'>
									Disable
								</button>
							</div>
						</div>
					);
				})}
			</div>
		</>
	);
}
